<template>
    <div class="tab-two-container">
        <swiper :options="swiperOption" ref="mySwiper" class="swiper-ul" v-show="!showVideo">
            <!-- slides -->
            <swiper-slide>
                <li>
                    <img src="../../../assets/images/guide-img/7-1.png"/>
                </li>
            </swiper-slide>
            <swiper-slide>
                <li>
                    <img src="../../../assets/images/guide-img/7-2.png"/>
                </li>
            </swiper-slide>
            <swiper-slide>
                <li>
                    <img src="../../../assets/images/guide-img/7-3.png"/>
                </li>
            </swiper-slide>
            <swiper-slide>
                <li>
                    <img src="../../../assets/images/guide-img/7-4.png"/>
                </li>
            </swiper-slide>
            <swiper-slide>
                <li>
                    <img class="viewImg" src="../../../assets/images/guide-img/1-7.png" @click="showVideo = true"/>
                </li>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
        <video v-if="showVideo" src="http://help.web724.cn/video/submitsite.mp4" controls autoplay></video>

        <div class="tab-two-footer">
            <ul>
                <li @click="showVideo = true"><img src="../../../assets/images/guide-img/视频1.png"/>观看视频</li>
                <li @click="switchStat('1')"><img src="../../../assets/images/guide-img/图文.png"/>查看图文帮助</li>
            </ul>
            <!--<div @click="$emit('step', '8')">下一步</div>-->
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
	name: 'TabTwo',
	data() {
		return {
			current: '1',
			showVideo: false,
			swiperOption: {
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
			}
		}
	},
	components:{
		swiper,swiperSlide
	},
	computed: {
		swiper() {
			return this.$refs.mySwiper.swiper
		}
	},
	methods: {
		switchStat(params) {
			this.showVideo = false
			// this.swiper.slideTo(params,100,false)

		},
	}
}
</script>

<style scoped lang="scss">
    .tab-two-container{
        height: 100%;position:relative;padding-bottom:40px;text-align: center;
        .swiper-ul{
            display: flex;position:relative;height:100%;
            li{
                width: 100%;margin:0px auto;text-align: center;height:100%;padding: 0px 46px;
                img{
                    max-width: 100%;max-height: 100%; display: inline-block; vertical-align: middle;
                }
                video{
                    width: 100%;
                    height: 100%;
                }
                &:after{
                    content:''; display: inline-block; height: 100%;
                    width: 0; vertical-align: middle;
                }
            }
            li.arrow{
                position:absolute;top:50%;margin-top:-23px;cursor:pointer;
                width: 46px;
                height: 46px;
                padding:0;
                img{
                    width: 46px;
                    height: 46px;

                }
                &:first-child{
                    left:0;
                }
                &:last-child{
                    right:0;
                    img{
                        transform: rotate(180deg);
                    }
                }
            }
        }
        video{
            height: 100%;
            width: 100%;
        }
        .tab-two-footer{
            position: absolute; display: flex;left:20px;
            width: 100%;
            bottom:0;
            ul{
                display: flex;
                li{margin-right:20px;cursor:pointer;height:40px;line-height: 40px;
                    img{
                        width: 24px;margin-right:5px;
                        height: 24px;vertical-align: middle;margin-top:-4px;
                    }
                }
            }
            div {
                position: absolute;
                bottom: 0;
                right: 45px;
                cursor: pointer;
                height: 40px;
                line-height: 40px;
            }

        }
        .viewImg{
            cursor:pointer;
        }
    }
</style>
